import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { getUserLocation } from "../../redux";
import { PageContent } from "../../components";
import { tabs } from "./helper";

import ShippingNav from "./ShippingNav";
import { prevSearchParamsHelper } from "../../helpers";

const Shipping = ({ defaultLocation }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState();
  const property = searchParams.get("view");
  const locationId = searchParams.get("location") || defaultLocation;

  const onSetValue = (id) => {
    const tab = tabs?.find((tab) => tab.id === id);
    if (!tab) return;

    const defaultParams = tab?.defaultSearchParams || {};
    const params = {
      view: id,
      ...defaultParams,
      ...(tab?.includeLocationParam && locationId
        ? { location: locationId }
        : {}),
    };

    localStorage && localStorage.setItem("Shipping-View", id);
    setSearchParams((prev) => prevSearchParamsHelper(params, prev));
    setValue(id);
  };

  useEffect(() => {
    const defaultId = localStorage
      ? localStorage.getItem("Shipping-View")
      : property;
    onSetValue(defaultId || tabs[0].id);
  }, [property, tabs]);

  const TAB = tabs?.find(({ id }) => id === value);
  const Element = TAB?.TabElement || Stack;

  return (
    <PageContent disablePadding>
      <Stack direction="row" height="100%" overflow="hidden">
        <ShippingNav {...{ value, setValue: onSetValue }} />
        <Element defaultLocation={defaultLocation} />
      </Stack>
    </PageContent>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export const ShippingPage = connect(mapStateToProps)(Shipping);
